<script setup lang="ts">
// EVENTS
const emit = defineEmits<{
    close: [];
}>();

// COMPOSABLES
// Owned by the modal body, which unmounts on close: every opening starts from an empty field.
const { inputValue, sellingMethod, isLoading, interpretPhase, turnstileContainerId, onSubmit } = useQuickSearch({
    onClose: () => emit('close'),
});
</script>

<template>
    <QuickSearchPanel
        v-model="inputValue"
        v-model:selling-method="sellingMethod"
        :is-loading="isLoading"
        :interpret-phase="interpretPhase"
        :turnstile-container-id="turnstileContainerId"
        has-dismiss-hint
        has-autofocus
        @submit="onSubmit()"
    />
</template>
